module.exports = __webpack_public_path__ + "img/symbol_5.14d88286.png";